import { Box, createTheme, styled } from "@mui/material"

export const customTheme = createTheme({
  typography: {
    fontFamily: ["Poppins"].join(","),
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          width: "408px",
          height: "40px",
          display: "flex",
          backgroundColor: "#FFFFFF",
          justifyContent: "space-between",
          border: "1px solid #BEBEBE",
          borderRadius: "4px",
          opacity: 1,
          marginRight: "18px",
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          marginTop: "6px",
          background: " 0% 0% no-repeat padding-box",
          boxShadow: " 0px 2px 8px #00000022",
          borderRadius: "4px",
          Opacity: 1,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          width: "408px",
        },
      },
    },
  },
})

export const MetricHeaderWrapper = styled(Box)({
  width: "100%",
  height: "auto",
  backgroundColor: "#F8F9FA",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "15px 24px 15px 24px",
})

export const MetricHeaderLeft = styled(Box)({})

export const MetricHeaderMid = styled(Box)({
  // border: "1px solid red",
  flex: 1,
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  padding: "auto 0",
  alignItems: "center",
  flexWrap: "wrap",
})

export const MetricHeaderRight = styled(Box)({
  marginTop: "20px",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
})
